import { useTranslation } from 'react-i18next'
import { Link as RouterLink } from 'react-router-dom'

import { Box, Button, Stack, Typography } from '@mui/material'

import CheckCircle from '@mui/icons-material/CheckCircle'

import responsiveHook from '@hooks/useResponsive'

import { CertificationCards } from '@pages/LandingPage/Home/components/HeroSection/components/CertificationCards'

import { TLGTypography } from '@components/TLGTypography'

import { scaleUpTransition } from '@utils/styles'

import {
  containerSx,
  getStartedForFreeButtonSx,
  heroImageBrightnessSx,
  heroImageSx,
  heroLeftSideContentSx,
  heroLeftSideWrapperSx,
  heroOverTitleSx,
  heroRightSideWrapperSx,
  heroSubtitleSx,
  heroTitleSx,
  mobileOrTabletCertificationCardsContainerSx,
} from './styles'

const HeroSection = () => {
  const { t } = useTranslation()

  const { isMobileOrTablet, isDesktop, ifDesktop } =
    responsiveHook.useResponsive()

  return (
    <Box data-testid="tech-vendors-benefits-hero-section" sx={containerSx}>
      <Stack direction="row" sx={heroLeftSideWrapperSx}>
        <Stack sx={heroLeftSideContentSx}>
          <Typography variant="h6" sx={heroOverTitleSx}>
            {t('Benefits')}
          </Typography>
          <TLGTypography
            responsiveVariant={{ xs: 'h5', md: 'h4', lg: 'h3' }}
            component="h1"
            sx={heroTitleSx}
          >
            {t('Traditional lead generation doesn’t work anymore')}
          </TLGTypography>
          <TLGTypography
            responsiveVariant={{ xs: 'subtitle1', md: 'h6' }}
            component="h2"
            sx={heroSubtitleSx}
          >
            <span>
              {t('Welcome to the future of tech marketing and sales.')}
            </span>
            <span>
              {t(
                'Be found by Tech Customers when they’re actively searching for solutions and services you offer.'
              )}
            </span>
            <span>{t(`Get more actionable leads and close more deals.`)}</span>
          </TLGTypography>

          <Button
            data-testid="subscribe-now-button"
            component={RouterLink}
            to="/signup#vendors"
            variant="contained"
            color="secondary"
            size="medium"
            endIcon={<CheckCircle />}
            sx={getStartedForFreeButtonSx}
          >
            {t('Subscribe Now')}
          </Button>

          {isMobileOrTablet && (
            <CertificationCards
              containerSx={mobileOrTabletCertificationCardsContainerSx}
            />
          )}
        </Stack>

        <Stack sx={heroRightSideWrapperSx}>
          <Box sx={heroImageBrightnessSx} />

          <Box
            alt={t('Buyer Dashboard')}
            loading="lazy"
            component="img"
            src="/images/vendor-dashboard-hero.webp"
            sx={{ ...heroImageSx, ...ifDesktop(scaleUpTransition) }}
          />

          {isDesktop && <CertificationCards />}
        </Stack>
      </Stack>
    </Box>
  )
}

export { HeroSection }
